import type { ElementType, ReactNode } from 'react';

import { useReveal } from '@shared/lib/useReveal';

import styles from './Reveal.module.css';

interface RevealProps {
  children: ReactNode;
  as?: ElementType | undefined;
  /** Задержка внутри группы, чтобы элементы появлялись по очереди. */
  index?: number | undefined;
  className?: string | undefined;
  id?: string | undefined;
}

/** Обёртка появления при скролле. Анимируются только transform и opacity. */
export function Reveal({ children, as: Tag = 'div', index = 0, className, id }: RevealProps) {
  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <Tag
      ref={ref}
      id={id}
      data-revealed={revealed}
      style={{ '--reveal-delay': `${index * 70}ms` } as React.CSSProperties}
      className={[styles.reveal, className].filter(Boolean).join(' ')}
    >
      {children}
    </Tag>
  );
}
